import { createHttpLink } from '@apollo/client'
import ApolloLinkTimeout from 'apollo-link-timeout'

import Config, { isDevEnv } from '@/config/config'
import { makeId } from '@/util/id'

const { VITE_APP_DEFAULT_TIMEOUT } = Config

const httpLink = createHttpLink({
  uri: `${Config.SERVER_URL}/graphql`,
  fetch: (uri, options) => {
    //@ts-expect-error: Property body does not exist on type RequestInit
    const operationName = JSON.parse(options.body).operationName
    //@ts-expect-error: Property headers does not exist on type RequestInit
    options.headers['X-Apollo-Operation-Name'] = operationName
    //@ts-expect-error: Property headers does not exist on type RequestInit
    options.headers['X-Apollo-Operation-Id'] = makeId()

    const uuid = isDevEnv ? operationName : makeId(9)

    return fetch(uri + '?uuid=' + uuid, options)
  },
})

const timeoutLink = new ApolloLinkTimeout(VITE_APP_DEFAULT_TIMEOUT ? parseInt(VITE_APP_DEFAULT_TIMEOUT) : 20000)

/**
 * @private only to be used in apolloClient.ts
 */
export const timeoutHttpLink = timeoutLink.concat(httpLink)
